import PropTypes from 'prop-types';
import {useState} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {Input} from 'semantic-ui-react';

const SearchBar = ({className, size}) => {
  const params = new URLSearchParams(useLocation().search);
  const [query, setQuery] = useState(params.get('q'));
  const history = useHistory();

  const search = () => {
    if (query) {
      history.push(`/search?q=${encodeURIComponent(query)}`);
    } else {
      history.push('/search');
    }
  };

  return (
    <Input
      aria-label="url-info"
      size={size}
      action={{
        'aria-label': 'search',
        'icon': 'search',
        'size': size,
        'onClick': () => search(),
      }}
      placeholder="Search for websites..."
      className={className}
      onChange={(_evt, data) => {
        setQuery(data.value);
      }}
      onKeyPress={evt => {
        if (evt.key === 'Enter') {
          search();
        }
      }}
      value={query || ''}
    />
  );
};

SearchBar.propTypes = {
  className: PropTypes.string,
  size: PropTypes.string,
};

SearchBar.defaultProps = {
  className: undefined,
  size: undefined,
};

export default SearchBar;
